import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ServicesService } from '../services.service';
import { ActivatedRoute, Router } from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {passwordMatchValidator} from '../validators/passwordmatch.validator';
import swal from 'sweetalert2';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

    header = 'l-header';
    navbar = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    changePasswordForm: FormGroup;

  constructor(private route: ActivatedRoute, private _service: ServicesService, private router: Router) { }

  ngOnInit() {

      this.changePasswordForm = new FormGroup({
          // tslint:disable-next-line
          current_password:  new FormControl('', [Validators.required]),
          password:  new FormControl('', [Validators.required]),
          password_confirmation:  new FormControl('', [Validators.required, passwordMatchValidator(('password'))]),
      });

      $('.tb-preloader-wave').fadeOut();
      $('#tb-preloader').delay(200).fadeOut('slow').remove();
  }

    changePassword() {
        const userData = JSON.parse(localStorage.getItem('userData'));
        const token = localStorage.getItem('userToken')
        this.changePasswordForm.value.email = userData ? userData.email : '';
        this.changePasswordForm.value.token = token ? token : '';
        this._service.changePassword(this.changePasswordForm.value).subscribe((data: any) => {
                if (data.status ==200) {
                    var that  = this;
                    swal({
                            title: 'Password change successfully !',
                            text : 'Please re-login with new password.',
                            type : 'success',
                          }).then(function(isConfirm) {
                              that.router.navigate(['login']);
                          });
                }else{
                    swal({
                            title: 'Ops!',
                            text: 'Something went wrong. Please Try again !',
                            type: 'error'
                          });
                }

            },
            (err: HttpErrorResponse) => {

            });
    }

}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/change-password/change-password.component.ts